import React from "react";
import { useEffect } from "react";

import './CircularProgress.scss';

function CircularProgress(props) {
    
  useEffect(()=> {
    function renderCircularProgressChart() {
        let progressBar = document.querySelector(`#${props.data.pbId}`);
        let valueContainer = document.querySelector(`#${props.data.vcId}`);
        let progressValue = 0;
        let progressEndValue = props.data.value;
        let speed = 10;
  
        let progress = setInterval(() => {
          if (progressValue >= progressEndValue) {
            clearInterval(progress);
            return;
          }
          progressValue = progressValue + 1;
          valueContainer.textContent = `${progressValue} %`;
          progressBar.style.background = `conic-gradient(
              #FFFFFF ${progressValue * 3.6}deg,
              ${'rgba(255,255,255,0.12)'} ${progressValue * 3.6}deg
          )`;
        }, speed);
  }
  renderCircularProgressChart();
  },[props]);
  return (
    <div className="cir-progress" id={props.data.pbId}>
      <div className="value-container" id={props.data.vcId}>0%</div>
      <img src={props.data.img} alt="#"/>
    </div>
  );
}

export default CircularProgress;
